import { useEffect, useState } from "react";
import { BannerItem, MapBannerWrapper } from "../Style/SearchStyles";
import {
  getSearchBanner,
  SearchBannerResponse,
} from "../../../../api/search-banner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

export const MapBanner = () => {
  const [data, setData] = useState<SearchBannerResponse[]>([]);

  const getData = async () => {
    try {
      const res = await getSearchBanner();
      setData(res);
    } catch (e) {
      setData([]);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <MapBannerWrapper>
      <Swiper
        className="banner-swiper"
        slidesPerView={1.1}
        centeredSlides={true}
        autoplay={{ delay: 4000 }}
        modules={[Autoplay]}
        spaceBetween={12}
      >
        {data.map((item, i) => (
          <SwiperSlide key={i}>
            <BannerItem onClick={() => window.location.replace(item.url)}>
              <img src="/image-web/search/banner-icon.svg" alt="icon" />
              <div className="content">
                <div className="title">{item.title}</div>
                <div className="sub-title">{item.subTitle}</div>
              </div>
            </BannerItem>
          </SwiperSlide>
        ))}
      </Swiper>
    </MapBannerWrapper>
  );
};
